import { render, staticRenderFns } from "./vat.vue?vue&type=template&id=3a2234e2&scoped=true&"
import script from "./vat.vue?vue&type=script&lang=js&"
export * from "./vat.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentStepTwoForms.styles.scss?vue&type=style&index=0&id=3a2234e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2234e2",
  null
  
)

export default component.exports